export enum HttpContentType {
  Json = 'application/json',
  MultipartFormData = 'multipart/form-data',
}
